import { styled } from 'stitches.config'

export const FooterCtaRoot = styled('section', {
  backgroundColor: '$primary-500',
  overflow: 'visible !important',
})

export const FooterContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '$2',
  paddingTop: '$6',
  paddingBottom: '$6',
})

export const FooterCtaTitle = styled('h5', {
  fontSize: '$h5 !important',
  textAlign: 'center',
  color: '$accent-white',
})
